import { FC, useState } from 'react';
import { Page } from '@/components/Page.tsx';
import { Headline } from '@telegram-apps/telegram-ui';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@/providers/NavigationProvider.tsx';
import { OrganizerWarning } from '@/components/SecretSanta/OrganizerWarning.tsx';
import { SecretSantaGameForm } from '@/components/SecretSanta/SecretSantaGameForm.tsx';
import { ShareGameDialog } from '@/components/SecretSanta/ShareGameDialog.tsx';
import { SecretSantaGame } from '@/api/types.ts';

export const CreateSecretSantaPage: FC = () => {
  const { t } = useTranslation();
  const { navigateToRoute } = useNavigation();
  const [step, setStep] = useState<'warning' | 'form' | 'share'>('warning');
  const [createdGame, setCreatedGame] = useState<SecretSantaGame | null>(null);

  const handleWarningConfirm = () => {
    setStep('form');
  };

  const handleWarningCancel = () => {
    navigateToRoute('/main/secret-santa');
  };

  const handleGameSaved = (game: SecretSantaGame) => {
    setCreatedGame(game);
    setStep('share');
  };

  const handleShareDone = () => {
    if (createdGame) {
      navigateToRoute(`/main/secret-santa/${createdGame.id}`, true);
    }
  };

  return (
    <Page>
      {step === 'warning' && (
        <OrganizerWarning onConfirm={handleWarningConfirm} onCancel={handleWarningCancel} />
      )}

      {step === 'form' && (
        <div className="p-3 pb-10">
          <Headline className="pl-2 text-center mb-4" weight="2">
            {t('secretSanta.create')}
          </Headline>
          <SecretSantaGameForm onSaved={handleGameSaved} />
        </div>
      )}

      {step === 'share' && createdGame && (
        <ShareGameDialog game={createdGame} onDone={handleShareDone} />
      )}
    </Page>
  );
};
